import './create.css';

import * as React from 'react';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Note from 'src/entities/Note';

import CancelWhite from '../../res/img/cancel_white.svg';
import Profile from '../../res/img/member.svg';

interface IProps {
  hideNewNoteForm: () => void;
  createNote: (note: Note) => void;
  members: Member[];
  account: Member;
  group: Group;
}

interface IState {
  note: Note;
  notifiedMembersId: number[];
}

class CreateComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      note: new Note(),
      notifiedMembersId: []
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.createNote = this.createNote.bind(this);
    this.toggleAllNotification = this.toggleAllNotification.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
  }

  render() {
    return (
      <div id="NewNoteForm">
        <div className="Header">
          <input
            className="InputText"
            placeholder="タイトル"
            value={this.state.note.title}
            onChange={this.onChangeTitle}
          />
          <div
            className="Cancel"
            onMouseUp={this.props.hideNewNoteForm}
            onTouchEnd={this.props.hideNewNoteForm}
          >
            <img src={CancelWhite} />
          </div>
        </div>
        <div className="Content">
          <textarea
            placeholder="ノートの本文"
            value={this.state.note.text}
            onChange={this.onChangeText}
          />
        </div>
        <div className="Actions">
          <button onMouseUp={this.createNote} onTouchEnd={this.createNote}>
            ノートを作成
          </button>

          <div className="Notifications">
            <div className="Title">通知：</div>

            <div className="AllNotified" onClick={this.toggleAllNotification}>
              全員
            </div>

            {this.props.members.map(member =>
              member !== undefined ? (
                <div
                  className={
                    this.state.notifiedMembersId.includes(member.id)
                      ? 'Notified'
                      : 'UnNotified'
                  }
                >
                  <img
                    src={member.profile !== null ? member.profile : Profile}
                    onClick={this.toggleNotification.bind(this, member.id)}
                  />
                  <div className="Name">
                    <span>{member.nameLast}</span>
                    <div className="Serif" />
                  </div>
                </div>
              ) : null
            )}
          </div>

          {/* {this.state.note.notify ? (
              <label className="File">
                <span>ファイルを添付</span>
                <input type="file" onChange={this.onChangeFile} />
              </label>
            ) : null} */}
        </div>
      </div>
    );
  }

  onChangeTitle(e: any) {
    const note = Object.assign({}, this.state.note);
    note.title = e.target.value;
    this.setState({
      note
    });
  }

  onChangeText(e: any) {
    const note = Object.assign({}, this.state.note);
    note.text = e.target.value;
    this.setState({
      note
    });
  }

  createNote() {
    const note = Object.assign({}, this.state.note);
    note.memberId = this.props.account.id;
    note.groupId = this.props.group.id;
    note.checkers = [];
    note.notifiedMembersId = this.state.notifiedMembersId;
    note.created = Date.now();

    this.props.createNote(note);

    this.setState({
      note: new Note()
    });

    if (this.state.note.title.length > 0 && this.state.note.text.length > 0) {
      this.props.hideNewNoteForm();
    }
  }

  toggleNoteNotify(e: any) {
    const note = Object.assign({}, this.state.note);
    note.notify = !note.notify;

    this.setState({
      note
    });
  }

  toggleNotification(memberId: number) {
    if (this.state.notifiedMembersId.includes(memberId)) {
      this.setState({
        notifiedMembersId: this.state.notifiedMembersId.filter(
          m => m !== memberId
        )
      });
    } else {
      this.setState({
        notifiedMembersId: [...this.state.notifiedMembersId, memberId]
      });
    }
  }

  toggleAllNotification() {
    if (this.props.members.length === this.state.notifiedMembersId.length) {
      this.setState({
        notifiedMembersId: []
      });
    } else {
      this.setState({
        notifiedMembersId: this.props.members.map(m => m.id)
      });
    }
  }

  onChangeFile(e: any) {
    const file: File = e.target.files[0];
    const note = Object.assign({}, this.state.note);

    if (file.size > 2 * 1024 * 1024) {
      alert('添付ファイルのサイズは2MB以下にしてください。');
    } else {
      const reader = new FileReader();
      const that = this;
      reader.onload = () => {
        note.attachment = {
          filename: file.name,
          content: reader.result
        };

        that.setState({
          note
        });
      };
      reader.readAsDataURL(file);
    }
  }
}

export default CreateComponent;



// WEBPACK FOOTER //
// ./src/components/Note/create.tsx